import React from "react";
import "./AboutUs.css";
import CMS from "../cms.json";

const about = CMS.about || {};
const paragraphs = about.paragraphs || [];
const ctas = about.cta || [];

const AboutSection = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-image-panel">
          <img
            src={about.image || "/images/about-thecreaks.jpg"}
            alt="The Creaks band members performing"
            className="about-image"
          />
          <div className="image-overlay"></div>
        </div>

        <div className="about-content-panel">
          <div className="about-header">
            <p className="about-overline">{about.overline || "About The Band"}</p>
            <h2 className="about-title">{about.title || "YOUNG SOUND FROM PRAGUE"}</h2>
          </div>

          <div className="about-text">
            {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
          </div>

          <div className="about-cta">
            {ctas.map((cta, i) => {
              const isExternal = cta.link?.startsWith("http");
              return (
                <a
                  key={i}
                  href={cta.link}
                  className={`cta-button ${cta.style || "secondary"}`}
                  target={isExternal ? "_blank" : undefined}
                  rel={isExternal ? "noopener noreferrer" : undefined}
                >
                  {cta.text}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
